import { Person } from 'src/app/people/models/person';
import { SeatStatus } from './seatStatus';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import _ from 'lodash';

export class Seat {
  public id: string;
  public positionId: string;
  public status: SeatStatus;
  public person: Person;
  public startDate: Date;
  public endDate: Date;
  public metadata: any;
  public attributes: Attribute[] = new Array<Attribute>();
  public isCurrent: boolean;
  public declineReason: string;
  public UpdatedOn: Date;

  constructor(
    id: string,
    positionId: string,
    status: SeatStatus,
    person: Person,
    startDate?: Date,
    endDate?: Date,
    metadata?: any,
    isCurrent?: boolean,
    declineReason?: string,
    updatedOn?: Date
  ) {
    this.id = id;
    this.positionId = positionId;
    this.status = status;
    this.startDate = startDate;
    this.endDate = endDate;
    this.metadata = metadata;
    this.isCurrent = isCurrent;
    this.declineReason = declineReason;
    this.UpdatedOn = updatedOn;
    if (person) this.person = new Person(person);
  }

  get statusDescription(): string {
    return SeatStatus[this.status];
  }

  updateAttribute(attributeDefinitionId: string, updatedAttributes: Attribute[]) {
    _.remove(this.attributes, { attributeDefinitionId: attributeDefinitionId });
    if (updatedAttributes) {
      this.attributes = _.orderBy(_.concat(this.attributes, updatedAttributes), 'name');
    }
  }

  setAttributes(attributes) {
    this.attributes = _.orderBy(
      _.map(attributes, function (attribute) {
        return Attribute.parse(attribute);
      }),
      'name'
    );
  }

  hasAttributes(): boolean {
    return this.attributes && this.attributes.length > 0;
  }

  static parse(obj: any): Seat {
    let seatStatus =
      typeof obj.status === 'number'
        ? SeatStatus[obj.status]
        : (obj.status as keyof typeof SeatStatus);
    let seat = new Seat(
      obj.id,
      obj.positionId,
      SeatStatus[seatStatus],
      obj.person,
      obj.startDate,
      obj.endDate,
      obj.metadata,
      obj.isCurrent,
      obj.declineReason,
      obj.updatedOn
    );
    if (obj.attributes) seat.setAttributes(obj.attributes);
    return seat;
  }
}
